export function filterWells(allUwis, wells, filters) {
  try {
    let filteredWells = {
      byUwi: {},
      allUwis: [],
      currentWellUwi: wells?.currentWellUwi
    };

    // console.log(allUwis);

    const filterNames = filters && Object.keys(filters);

    allUwis?.forEach(uwi => {
      if (uwi?.length > 0) {
        const numFilters = filterNames?.length;
        const well = wells?.byUwi[uwi];

        if (well) {
          let matchCount = 0;
          filterNames?.forEach(filterName => {
            if (filterName === 'dateFrom') {
              if (well?.details?.on_prod_date && (new Date(well?.details?.on_prod_date) >= new Date(filters[filterName]))) matchCount++;
            } else if (filterName === 'dateTo') {
              if (well?.details?.on_prod_date && (new Date(well?.details?.on_prod_date) <= new Date(filters[filterName]))) matchCount++; 
            } else if (filterName === 'symbol') {
              if (well?.details?.[filterName]?.toLowerCase() === filters[filterName]?.toLowerCase()) matchCount++;
            } else if (filterName === 'producingFluid') {
              let fluidMatch = 0;
              filters?.producingFluid?.forEach(fluid => {
                if (well?.status === 'processed' && well?.production?.fluids?.indexOf(fluid?.toLowerCase()) !== -1) fluidMatch++;
              });
              if (fluidMatch === filters?.producingFluid?.length) matchCount++;
            } else if (filterName === 'status') {
              if (filters?.status?.indexOf(well?.status.toUpperCase()) !== -1) matchCount++;
            } else {
              if (filters?.[filterName]?.indexOf(well?.details?.[filterName]) !== -1) matchCount++;
            };
          });
    
          if (matchCount === numFilters) {
            filteredWells.byUwi[uwi] = well;
            filteredWells.allUwis.push(uwi);
          };
        };
      };
    });

    return filteredWells;
  } catch (error) {
    console.log('Could not filter wells!');
    return wells;
  };
};